module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//25.jpg?90dc5aff5e3ddc7f99f43418aa0100d3";